import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import aiDevelopmentService from "../../services/aiDevelopmentService";
import { roleProvider, withRoleProvider } from "./AiDevelopmentProjectsPage";
import "./AiDevelopmentStudio.css";

const ROLES = [
  { key: "developer", label: "aiDevelopment.developerExecutionProvider" },
  { key: "qa", label: "aiDevelopment.qaExecutionProvider" },
  { key: "planner", label: "aiDevelopment.plannerExecutionProvider" },
];

export default function AiGlobalExecutionSettingsPage() {
  const { t } = useTranslation();
  const [providerConfiguration, setProviderConfiguration] = useState("{}");
  const [version, setVersion] = useState(0);
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const settings = await aiDevelopmentService.globalExecutionSettings();
      setProviderConfiguration(settings.providerConfiguration || "{}");
      setVersion(settings.version || 0);
    } catch (e) {
      setError(e?.message || t("common.errorOccurred"));
    } finally {
      setLoading(false);
    }
  }, [t]);
  useEffect(() => {
    load();
  }, [load]);
  useEffect(() => {
    aiDevelopmentService
      .executionProviders()
      .then((list) => setProviders((list || []).filter((p) => p.enabled)))
      .catch(() => setProviders([]));
  }, []);

  const setRoleProvider = (role, provider) =>
    setProviderConfiguration(
      withRoleProvider(providerConfiguration, role, provider),
    );

  const save = async (e) => {
    e.preventDefault();
    setError("");
    setSaved(false);
    try {
      JSON.parse(providerConfiguration);
      setLoading(true);
      const result = await aiDevelopmentService.updateGlobalExecutionSettings(
        { providerConfiguration, version },
      );
      setProviderConfiguration(result.providerConfiguration || "{}");
      setVersion(result.version || 0);
      setSaved(true);
    } catch (err) {
      setError(
        err instanceof SyntaxError
          ? t("aiDevelopment.invalidJson")
          : err?.message || t("common.errorOccurred"),
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ai-studio-page">
      <header className="ai-studio-header">
        <div>
          <h1>{t("aiDevelopment.globalExecutionSettings")}</h1>
          <p>{t("aiDevelopment.globalExecutionSettingsSubtitle")}</p>
        </div>
      </header>
      {error && <div className="ai-studio-alert">{error}</div>}
      <form className="ai-studio-panel ai-create-form" onSubmit={save}>
        <div className="ai-form-grid">
          {ROLES.map(({ key, label }) => (
            <label key={key}>
              {t(label)}
              <select
                value={roleProvider(providerConfiguration, key)}
                onChange={(e) => setRoleProvider(key, e.target.value)}
              >
                <option value="">{t("aiDevelopment.useBootstrapDefault")}</option>
                {providers.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.id}
                  </option>
                ))}
              </select>
            </label>
          ))}
        </div>
        <div className="ai-actions">
          <button className="btn btn-primary" disabled={loading} type="submit">
            {t("common.save")}
          </button>
          {saved && (
            <span className="ai-status">{t("aiDevelopment.settingsSaved")}</span>
          )}
        </div>
      </form>
    </div>
  );
}
